<div [class.knx-kind-light]="kind === 'light'" [class.knx-kind-socket]="kind === 'socket'">

  <!-- Loading: no "knxDevices" frame yet -->
  <ng-container *ngIf="!summary">
    <div class="row g-2 mb-3">
      <div class="col-6 col-sm-3" *ngFor="let _ of skeletonTiles">
        <div class="card h-100">
          <div class="card-body p-2 p-sm-3">
            <app-skeleton width="60%" height=".7rem" radius="4px" [darkMode]="darkMode" style="display:block;margin-bottom:.4rem;"></app-skeleton>
            <app-skeleton width="45%" height="1.4rem" radius="4px" [darkMode]="darkMode" style="display:block;"></app-skeleton>
          </div>
        </div>
      </div>
    </div>
    <!-- mobile view: list rows like the room list -->
    <div *ngIf="listView.matches" class="card dash-list mb-3">
      <div class="dash-row knx-lrow" *ngFor="let _ of skeletonCards">
        <span class="knx-lrow-state" aria-hidden="true"></span>
        <app-skeleton width="6rem" height=".9rem" radius="4px" [darkMode]="darkMode" style="display:block;"></app-skeleton>
        <app-skeleton width="6rem" height="1.4rem" radius="999px" [darkMode]="darkMode" style="display:block;justify-self:end;"></app-skeleton>
      </div>
    </div>
    <div *ngIf="!listView.matches" class="row g-2 mb-3">
      <div class="col-6 col-lg-4" *ngFor="let _ of skeletonRooms">
        <div class="card">
          <div class="card-body p-2 p-sm-3">
            <app-skeleton width="50%" height=".85rem" radius="4px" [darkMode]="darkMode" style="display:block;margin-bottom:.6rem;"></app-skeleton>
            <div class="d-flex align-items-center gap-2 mb-2" *ngFor="let _ of skeletonRooms">
              <app-skeleton width="70%" height=".8rem" radius="4px" [darkMode]="darkMode" style="flex:1;"></app-skeleton>
              <app-skeleton width="3.2rem" height="1.1rem" radius="999px" [darkMode]="darkMode" style="flex-shrink:0;"></app-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="summary as s">

    <div class="dash-section-head">
      <div class="dash-section-title">
        <span class="badge bg-danger dash-live"><span [style.opacity]="liveDotOn ? '1' : '0'">●</span> LIVE</span>
        <span class="dash-section-name">{{ cfg.icon }} {{ cfg.title | translate }}</span>
        <span *ngIf="updatedAt" class="dash-section-age">· {{ 'UPDATED_AGO' | translate:{time: updatedAgo(updatedAt)} }}</span>
      </div>
    </div>

    <div *ngIf="!s.total" class="card mb-3">
      <div class="card-body p-3 text-muted small">{{ 'KNX_NO_DEVICES' | translate }}</div>
    </div>

    <ng-container *ngIf="s.total">

      <!-- a) Summary tiles: 2 per row on phones, 4 from small screens (lights: "last switched" then spans the width); one row on large screens -->
      <div class="row g-2 mb-3" [class.section-flash]="flash">
        <div class="col-6 col-sm-3 col-lg">
          <div class="card h-100">
            <div class="card-body p-2 p-sm-3">
              <div class="knx-tile-label"><i class="knx-swatch"></i>{{ 'KNX_ON_COUNT' | translate }}</div>
              <div class="knx-tile-value">{{ s.on }}<span class="knx-tile-sub fw-normal"> / {{ s.total }}</span></div>
            </div>
          </div>
        </div>
        <div class="col-6 col-sm-3 col-lg">
          <div class="card h-100">
            <div class="card-body p-2 p-sm-3">
              <div class="knx-tile-label"><i class="knx-swatch knx-swatch-off"></i>{{ 'KNX_OFF_COUNT' | translate }}</div>
              <div class="knx-tile-value">{{ s.off }}<span class="knx-tile-sub fw-normal"> / {{ s.total }}</span></div>
            </div>
          </div>
        </div>
        <div class="col-6 col-sm-3 col-lg">
          <div class="card h-100">
            <div class="card-body p-2 p-sm-3">
              <div class="knx-tile-label">{{ cfg.roomsOn | translate }}</div>
              <div class="knx-tile-value">{{ s.roomsOn }}<span class="knx-tile-sub fw-normal"> / {{ s.rooms }}</span></div>
            </div>
          </div>
        </div>
        <div *ngIf="s.dimmers" class="col-6 col-sm-3 col-lg">
          <div class="card h-100">
            <div class="card-body p-2 p-sm-3">
              <div class="knx-tile-label">{{ 'KNX_DIMMERS_ON' | translate }}</div>
              <div class="knx-tile-value">{{ s.dimmersOn }}<span class="knx-tile-sub fw-normal"> / {{ s.dimmers }}</span></div>
              <div class="knx-tile-sub" *ngIf="s.avgDimPct != null">{{ 'KNX_DIM_AVG' | translate:{pct: s.avgDimPct} }}</div>
            </div>
          </div>
        </div>
        <div [ngClass]="s.dimmers ? 'col-12 col-lg' : 'col-6 col-sm-3 col-lg'">
          <div class="card h-100">
            <div class="card-body p-2 p-sm-3">
              <div class="knx-tile-label">{{ 'KNX_LAST_SWITCHED' | translate }}</div>
              <ng-container *ngIf="s.last as l; else noChange">
                <div class="knx-tile-value text-nowrap" [title]="l.sinceFull">{{ l.since }}<span class="knx-tile-sub fw-semibold"> → {{ l.stateKey ? (l.stateKey | translate) : '–' }}</span></div>
                <div class="knx-tile-sub text-truncate m-wrap" [title]="(l.name | knxName:lang:'device') + (s.lastWhere ? ' · ' + s.lastWhere : '')">{{ l.name | knxName:lang:'device' }}<ng-container *ngIf="s.lastWhere"> · {{ s.lastWhere }}</ng-container></div>
              </ng-container>
              <ng-template #noChange>
                <div class="knx-tile-value">–</div>
                <div class="knx-tile-sub">{{ 'KNX_NO_CHANGE_SEEN' | translate }}</div>
              </ng-template>
            </div>
          </div>
        </div>
      </div>

      <!-- b) Filter (display only: nothing here switches a device); phones: a full-width segmented control -->
      <div class="d-flex align-items-center gap-2 mb-2 flex-wrap">
        <span class="knx-hint text-muted">🔒 {{ 'KNX_READ_ONLY' | translate }}</span>
        <div class="btn-group btn-group-sm ms-auto dash-seg dash-seg-xs" role="group" [attr.aria-label]="'KNX_FILTER' | translate">
          <button type="button" class="btn" [ngClass]="onlyOn ? 'btn-outline-secondary' : 'btn-secondary'"
                  [attr.aria-pressed]="!onlyOn" (click)="setOnlyOn(false)">{{ 'KNX_ALL' | translate }} · {{ s.total }}</button>
          <button type="button" class="btn" [ngClass]="onlyOn ? 'btn-secondary' : 'btn-outline-secondary'"
                  [attr.aria-pressed]="onlyOn" (click)="setOnlyOn(true)">{{ 'KNX_ONLY_ON' | translate }} · {{ s.on }}</button>
        </div>
      </div>

      <!-- c) Floor → room cards -->
      <div *ngIf="!floors.length" class="card mb-3">
        <div class="card-body p-3 text-muted small">{{ cfg.allOff | translate }}</div>
      </div>
      <!-- Mobile view (< 768 px): one list row per room — accent bar while a device is on, the name, its devices as chips in their
           state (filled = on, outlined = off), right-aligned so the states line up -->
      <div *ngIf="floors.length && listView.matches" class="card dash-list mb-3" [class.section-flash]="flash">
        <ng-container *ngFor="let f of floors; trackBy: trackFloor">
          <div class="dash-list-group">{{ (f.floor | knxName:lang:'floor') ?? ('KNX_NO_ROOM' | translate) }}</div>
          <div *ngFor="let r of f.rooms; trackBy: trackRoom" class="dash-row knx-lrow">
            <span class="knx-lrow-state" [class.on]="r.on > 0" aria-hidden="true"></span>
            <div class="knx-lrow-name">{{ (r.room | knxName:lang:'room') ?? (f.floor | knxName:lang:'floor') ?? ('KNX_NO_ROOM' | translate) }}</div>
            <div class="knx-chips" [title]="('KNX_ON_COUNT' | translate) + ': ' + r.on + ' / ' + r.total">
                <span *ngFor="let d of r.items; trackBy: trackRow" class="knx-chip" [ngClass]="d.pillCls"
                      [title]="(d.name | knxName:lang:'device') + ': ' + (d.stateKey ? (d.stateKey | translate) : ('KNX_STATE_UNKNOWN' | translate)) + (d.sinceFull ? ' · ' + ('KNX_SINCE' | translate:{time: d.sinceFull}) : '')">
                  <ng-container *ngIf="d.state === 'on'">
                    <svg *ngIf="kind === 'light'" viewBox="0 0 16 16" aria-hidden="true">
                      <path fill="currentColor" d="M8 .8a5.2 5.2 0 0 0-3.1 9.4c.6.45 1 1.05 1 1.75v.35h4.2v-.35c0-.7.4-1.3 1-1.75A5.2 5.2 0 0 0 8 .8z"/>
                      <rect fill="currentColor" x="5.9" y="13" width="4.2" height="1.2" rx=".6"/>
                      <rect fill="currentColor" x="6.6" y="14.6" width="2.8" height="1.1" rx=".55"/>
                    </svg>
                    <svg *ngIf="kind === 'socket'" viewBox="0 0 16 16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                      <path d="M8 1.6v6"/><path d="M4.4 4.2a5.4 5.4 0 1 0 7.2 0"/>
                    </svg>
                  </ng-container>{{ d.name | knxName:lang:'device' }}<span *ngIf="d.brightness != null" class="knx-chip-extra">{{ d.brightness }}&nbsp;%</span><span
                    *ngIf="d.state === 'on' && d.since" class="knx-chip-extra">{{ 'KNX_SINCE' | translate:{time: d.since} }}</span>
                </span>
            </div>
          </div>
        </ng-container>
      </div>

      <!-- From 768 px: one card per room with a row per device -->
      <div *ngIf="!listView.matches" class="mb-3">
        <ng-container *ngFor="let f of floors; trackBy: trackFloor">
          <div class="knx-floor fw-semibold text-uppercase text-muted mb-1">{{ (f.floor | knxName:lang:'floor') ?? ('KNX_NO_ROOM' | translate) }}</div>
          <div class="row g-2 mb-2" [class.section-flash]="flash">
            <div class="col-6 col-lg-4 col-xxl-3" *ngFor="let r of f.rooms; trackBy: trackRoom">
              <div class="card h-100 knx-room" [class.knx-room-on]="r.on > 0">
                <div class="card-body p-2 px-sm-3">
                  <div class="d-flex align-items-baseline gap-2">
                    <span class="knx-room-title fw-semibold text-truncate flex-grow-1 min-w-0">{{ (r.room | knxName:lang:'room') ?? (f.floor | knxName:lang:'floor') ?? ('KNX_NO_ROOM' | translate) }}</span>
                    <span class="knx-room-count" [title]="('KNX_ON_COUNT' | translate) + ': ' + r.on + ' / ' + r.total"><b>{{ r.on }}</b> / {{ r.total }}</span>
                  </div>
                  <div class="knx-row" *ngFor="let d of r.items; trackBy: trackRow">
                    <div class="flex-grow-1 min-w-0">
                      <div class="knx-name text-truncate" [title]="d.name | knxName:lang:'device'">{{ d.name | knxName:lang:'device' }}</div>
                      <div *ngIf="d.since" class="knx-since text-truncate" [title]="d.sinceFull">{{ 'KNX_SINCE' | translate:{time: d.since} }}</div>
                    </div>
                    <div *ngIf="d.brightness != null" class="knx-dim" [title]="('KNX_BRIGHTNESS' | translate) + ' ' + d.brightness + ' %'">
                      {{ d.brightness }}&nbsp;%
                      <span class="knx-dim-bar"><span [style.width.%]="d.brightness"></span></span>
                    </div>
                    <span class="knx-pill" [ngClass]="d.pillCls" [attr.title]="d.stateKey ? null : ('KNX_STATE_UNKNOWN' | translate)">
                      <ng-container *ngIf="d.state === 'on'">
                        <!-- lamp -->
                        <svg *ngIf="kind === 'light'" viewBox="0 0 16 16" aria-hidden="true">
                          <path fill="currentColor" d="M8 .8a5.2 5.2 0 0 0-3.1 9.4c.6.45 1 1.05 1 1.75v.35h4.2v-.35c0-.7.4-1.3 1-1.75A5.2 5.2 0 0 0 8 .8z"/>
                          <rect fill="currentColor" x="5.9" y="13" width="4.2" height="1.2" rx=".6"/>
                          <rect fill="currentColor" x="6.6" y="14.6" width="2.8" height="1.1" rx=".55"/>
                        </svg>
                        <!-- power -->
                        <svg *ngIf="kind === 'socket'" viewBox="0 0 16 16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                          <path d="M8 1.6v6"/><path d="M4.4 4.2a5.4 5.4 0 1 0 7.2 0"/>
                        </svg>
                      </ng-container>{{ d.stateKey ? (d.stateKey | translate) : '–' }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </div>

    </ng-container>
  </ng-container>
</div>
